import React from 'react';
// 컴포넌트
import BackHeader from '../component/BackHeader';
import { Layout } from '../component/Styled';
// 이미지
import enrollImg from '../../src/asset/img/enroll.png';
import kakaoButton from '../../src/asset/img/kakaoButton.svg';

const Enrolintro = () => {
  return (
    <Layout>
      <BackHeader ment="이용안내" />
      {/* <Box /> */}
      <div className="mt-20 align-center">
        <img width={'100%'} src={enrollImg} alt="이미지" />
      </div>
      <div
        style={{
          padding: 15,
          backgroundColor: '#f5f5f5',
          borderRadius: 5,
          whiteSpace: 'pre-wrap'
        }}>
        마이페이지 이용을 원하는 청소년은 일하루 담당자에게 연락주시면
        <br />
        친절하게 안내를 도와드리겠습니다.
        <div style={{ marginTop: 20 }}>➡ 문의 및 담당자</div>
        <li>담당자: 학교밖지원팀 서미영, 김수진, 서혜정</li>
        <li>연락처: 031-729-9180~2</li>
      </div>
      <div
        className="text-center  mt-10
      ">
        <a href="https://pf.kakao.com/_LJGSxb" target="_blank" rel="noreferrer">
          <img width={'100%'} src={kakaoButton} alt="이미지" />
        </a>
      </div>
    </Layout>
  );
};

export default Enrolintro;
